import { useCallback } from 'react';

import { Container, LeftSection, RightSection, StickyPageHeaderSkeletonWithButtons } from '@/_containers';
import { SecondaryPageLayoutLoading } from '@/_containers/layout/secondary-page-layout';
import SupportLoading from '@/_containers/support/list/loading';
import { TicketDetailsRightSectionLoading } from '@/_containers/support/ticket-details/components/right-section';
import SupportTicketDetailLoading from '@/_containers/support/ticket-details/loading';
import AgreementsLoading from '@/_pages/companies/agreements/loading';
import ApiIntegrationLoading from '@/_pages/companies/api-integration/loading';
import ContactsLoading from '@/_pages/companies/contacts/loading';
import DomainsLoading from '@/_pages/companies/domains/loading';
import FinancialsLoading from '@/_pages/companies/financials/loading';
import InvoiceHistoryLoading from '@/_pages/companies/invoice-history/loading';
import MarketingCampaignsLoading from '@/_pages/companies/marketing-campaigns/loading';
import NotesLoading from '@/_pages/companies/notes/loading';
import ProfileLoading from '@/_pages/companies/profile/loading';
import { ProfileRightSectionLoading } from '@/_pages/companies/profile/right-section';
import { HeaderLoading } from '@/_pages/companies/shared/components/header-section';
import { companiesSubNav, useCurrentLocation } from '@/_shared';

export function TemplateLoading() {
  const { matched } = useCurrentLocation();
  const { tabKey, renderRightColumn } = matched?.staticData ?? {};

  const render = useCallback(() => {
    switch (tabKey) {
      case 'client/agreements':
        return <AgreementsLoading />;
      case 'client/api-integration':
        return <ApiIntegrationLoading />;
      case 'client/contacts':
        return <ContactsLoading />;
      case 'client/domains':
        return <DomainsLoading />;
      case 'client/financials':
        return <FinancialsLoading />;
      case 'client/invoice-history':
        return <InvoiceHistoryLoading />;
      case 'client/marketing-campaigns':
        return <MarketingCampaignsLoading />;
      case 'client/notes':
        return <NotesLoading />;
      case 'client/support':
        return <SupportLoading />;
      case 'client/support/details':
        return <SupportTicketDetailLoading />;
      case 'client/profile':
      case 'client/subscriptions':
      default:
        return <ProfileLoading />;
    }
  }, [tabKey]);

  return (
    <SecondaryPageLayoutLoading subNavLinks={companiesSubNav}>
      <StickyPageHeaderSkeletonWithButtons numberOfButtons={2} allowBack />
      <Container>
        <LeftSection forceFullWidth={matched?.staticData?.isFullWidth}>
          {matched?.staticData?.tabKey !== 'client/support/details' && (
            <HeaderLoading editable={matched?.staticData?.hasEditableHeader} />
          )}
          {render()}
        </LeftSection>
        {renderRightColumn && (
          <RightSection>
            {matched?.staticData?.tabKey !== 'client/support/details' && <ProfileRightSectionLoading />}
            {matched?.staticData?.tabKey === 'client/support/details' && <TicketDetailsRightSectionLoading />}
          </RightSection>
        )}
      </Container>
    </SecondaryPageLayoutLoading>
  );
}
